import { Deserializable } from '../../protocols/deserializable';
import { UniquelyIdentifiable } from '../../protocols/uniquely-identifiable';
import { HighGuideInsightCollectionBrand } from './high-guide-insight-collection-brand';
import { HighGuideInsightCollectionProduct } from './high-guide-insight-collection-product';

/**
 * The computed results for one configured Purchasing Insight.
 *
 * `id`, `name` and `recommendationTags` echo the company's own `InsightCollection`, so results join back to the
 * configured collection on `id`. A configured collection may come back with empty `products` and `brands`, or may
 * not come back at all - consumers must treat both as the same thin-data state rather than reading a missing entry
 * as "still loading".
 */
export class HighGuideInsightCollectionResult implements Deserializable, UniquelyIdentifiable {
  public id: string;
  public name: string;
  public recommendationTags: string[];
  public products: HighGuideInsightCollectionProduct[];
  public brands: HighGuideInsightCollectionBrand[];

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.recommendationTags = Array.from(this.recommendationTags || []);
    this.products = Deserialize?.arrayOf(HighGuideInsightCollectionProduct, this.products) || [];
    this.brands = Deserialize?.arrayOf(HighGuideInsightCollectionBrand, this.brands) || [];
  }

  hasResults(): boolean {
    return this.products?.length > 0 || this.brands?.length > 0;
  }

  getUniqueIdentifier(): string {
    return `
      -${this.id}
      -${this.name}
      -${this.recommendationTags?.join(',')}
      -${this.products?.map(product => product?.getUniqueIdentifier())?.join(',')}
      -${this.brands?.map(brand => brand?.getUniqueIdentifier())?.join(',')}
    `;
  }
}
